import { Button, Modal } from "antd";
import React from "react";
import ReactPlayer from "react-player";

const Player = ({ link }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <Button type="primary" onClick={() => setOpen(true)}>
        Play
      </Button>

      <Modal
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={800}
        footer={null}
      >
        <ReactPlayer url={link} width="100%" />
      </Modal>
    </div>
  );
};

export default Player;
